import { Injector } from "@angular/core";
import { WorkplaceActionHandlerBase } from "../../../../../../components/common/grid-base/actions/workplace-action-handler-base";
import { WorkplaceBase } from "../../../../../../components/common/workplace-base/workplace-base";

/**
 * Handles a tab selection
 */
export class TabSelectedWorkplaceActionHandler extends WorkplaceActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workplace: WorkplaceBase) {
    super(injector, workplace, 'valuationTabSelect');
  }

  /**
  * Handles an event
  * @param payload The (untyped) payload. Can also be a callback function
  */
  public handle(payload: any): void {
    this.workplace.selectedTab = "#" + payload;
    const tab = this.workplace.tabConfig.find((en) => { return en.id === payload });
    if (tab) {
      this.workplace.searchMode = tab.searchMode;
    }
    this.eventBus.broadcastEvent("toolbarSetArea", this.workplace.searchMode);
  }
}
